import React, { useEffect, useState } from 'react';
import { Input, Pagination, Popconfirm, Select } from 'antd';
import { API_GET_FEED_BACK } from 'config/data';
import { FEED_BACK_TYPE, getStatusClass } from 'utils/data';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useMasterFeedBackTypeSelector } from '../../../../redux/selector';
import { FeedBackModel } from 'interface/FeedBack';
import { deleteFeedbackById, FEED_BACK_PAGE_SIZE, getFeedBacks } from 'service/feedBackService';
import FeedbackModal from './modal/FeedBackModal';
import { AppState } from 'interface/stateApp';
import { convertDateTime, getUrlPage, isValid } from 'utils/helper';
import toast, { NotifyType } from 'utils/toast';
import { useNavigate, useSearchParams } from 'react-router-dom';

const { Option } = Select;

export const FeedBack: React.FC = () => {
  const feedbackTypes = useMasterFeedBackTypeSelector();
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState<number>(FEED_BACK_PAGE_SIZE);
  const [searchParams] = useSearchParams();
  const [feedBackSize, setFeedBackSize] = useState(0);
  const [feedBacks, setFeedBacks] = useState<FeedBackModel[]>([]);
  const [feedBackSelected, setFeedBackSelected] = useState<FeedBackModel | null>(null);
  const [stateApp, setStateApp] = useState<AppState>({
    showFeedBack: false,
  });

  const navi = useNavigate();


  const getData = (url?: string) => {

    getFeedBacks(url)
      .then((data) => {
        setFeedBacks(data?.content);
        setFeedBackSize(data?.totalElements);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let input = event.currentTarget.value;
    if (event.key === 'Enter') {
      if (input !== '') {
        navi(`/qna-tickets/feedbacks?keyword=${input}`);
      } else {
        navi(`/qna-tickets/feedbacks`);
      }
    }
  };

  const handleOnchangeSelect = (value: string, type: string) => {
    if (type === 'feedBackType') {
      if (value === 'all') {
        navi(`/qna-tickets/feedbacks`);
      } else {
        navi(`/qna-tickets/feedbacks?feedBackTypeId=${value}`);
      }
    } else {
      if (value === 'all') {
        navi(`/qna-tickets/feedbacks`);
      } else {
        navi(`/qna-tickets/feedbacks?status=${value}`);
      }
    }
  };

  const handlePageChange = (page: number, pageSize?: number) => {
    setCurrentPage(page);
    setPageSize(pageSize ? pageSize : FEED_BACK_PAGE_SIZE);
    const searchParam = searchParams.get('keyword');
    const feedBackTypeId = searchParams.get('feedBackTypeId');
    const status = searchParams.get('status');
    let url = '/feedback';
    if (isValid(feedBackTypeId)) {
      url += `?feedBackTypeId=${feedBackTypeId}`;
      getData(getUrlPage(url, page, pageSize ? pageSize : FEED_BACK_PAGE_SIZE));
      return;
    }
    if (isValid(searchParam)) {
      url += `?keyword=${searchParam}`;
      getData(getUrlPage(url, page, pageSize ? pageSize : FEED_BACK_PAGE_SIZE))
      return;
    }
    if (isValid(status)) {
      url += `?status=${status}`;
      getData(getUrlPage(url, page, pageSize ? pageSize : FEED_BACK_PAGE_SIZE))
      return;
    }
    getData(getUrlPage(url, page, pageSize ? pageSize : FEED_BACK_PAGE_SIZE))
  };

  const handleSelectFeedBack = (value: any) => {
    setFeedBackSelected(value);
    setStateApp({ ...stateApp, showFeedBack: true });
  };

  const handleDelete = (id: string) => {
    deleteFeedbackById(id)
      .then(() => {
        toast(NotifyType.SUCCESS, 'Xóa thành công');
        setFeedBacks(feedBacks.filter((feedback) => feedback.id !== id));
      })
      .catch((error) => {
        toast(NotifyType.ERROR, 'Xóa thất bại vui lòng thử lại');
      });
  };

  useEffect(() => {
    handlePageChange(0);
  }, [searchParams]);
  return (
    <div className="container flex flex-col mx-auto p-4 h-[98%]">
      <div className="p-2 flex items-center justify-between bg-white rounded">
        <div className="flex gap-4">
          <FeedbackModal
            stateApp={stateApp}
            setStateApp={setStateApp}
            data={feedBackSelected}
            updateData={getData}
          ></FeedbackModal>
          <div className="min-w-[170px] max-w-[170px] flex items-center gap-2">
            <Select className="w-full" placeholder="Loại gói - Tất cả" defaultValue={'all'} style={{ flex: 1 }}
              onChange={(value) => handleOnchangeSelect(value,'feedBackType')}>
              <Option value="all">Loại góp ý - Tất cả</Option>
              {feedbackTypes?.map((feedbackType: any) => (
                <Option key={feedbackType?.id} value={feedbackType?.id}>
                  {feedbackType?.name}
                </Option>
              ))}
            </Select>
          </div>
          <div className="min-w-[170px] max-w-[170px] flex items-center gap-2">
            <Select className="w-full" placeholder="Loại gói - Tất cả" defaultValue={'all'} style={{ flex: 1 }}
            onChange={(value) => handleOnchangeSelect(value,'status')}
            >
              <Option value="all">Trạng thái - Tất cả</Option>
              <Option value={FEED_BACK_TYPE.OPEN}>Mở</Option>
              <Option value={FEED_BACK_TYPE.CLOSE}>Đóng</Option>
            </Select>
          </div>
        </div>
        <Input placeholder="Nhập từ khóa tìm kiếm" name="keyword" className="w-fit" onKeyDown={handleKeyPress} />
      </div>
      <div className="flex flex-col bg-white h-[100%] p-2 rounded-sm">
        <div className="overflow-x-auto bg-white">
          <table className="min-w-full bg-white border border-gray-300">
            <thead className="bg-[#f2f2f2]">
              <tr>
                <th className="border border-gray-300 text-center py-3 px-4 font-semibold text-sm">Chọn</th>
                <th className="border border-gray-300 text-left py-3 px-4  font-semibold text-sm">Nội dung góp ý</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Loại góp ý</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Thời gian tạo</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Trạng thái</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Hành động</th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {feedBacks?.map((feedback: any) => (
                <tr key={feedback?.id}>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">
                    <input type="checkbox" />
                  </td>
                  <td className="border border-gray-300 text-left py-3 px-4 break-words cursor-pointer">
                    {feedback?.feedBackContent}
                  </td>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">
                    {feedback?.feedBackType?.name}
                  </td>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">
                    {feedback?.createdAt !== null ? convertDateTime(feedback.createdAt) : null}
                  </td>
                  <td
                    className={`border border-gray-300 text-center py-3 px-4 break-words ${getStatusClass(feedback?.status)}`}
                  >
                    {feedback?.status === FEED_BACK_TYPE.OPEN ? 'Đang mở' : 'Đóng'}
                  </td>

                  <td className="flex items-center justify-center border border-gray-300 text-center py-3 border-b-0">
                    <button
                      className="bg-blue-500 hover:bg-blue-700 text-white py-1 rounded-lg mx-1 w-[40px]"
                      onClick={() => handleSelectFeedBack(feedback)}
                    >
                      <EditOutlined />
                    </button>
                    <Popconfirm
                      title="Bạn có chắc muốn xóa góp ý này?"
                      onConfirm={() => handleDelete(feedback?.id)}
                      okText="Có"
                      cancelText="Không"
                    >
                      <button className="bg-red-500 hover:bg-red-700 text-white py-1 rounded-lg mx-1 w-[40px]">
                        <DeleteOutlined />
                      </button>
                    </Popconfirm>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* <div className="flex-grow"></div> */}
        <div className="flex justify-end mt-3 mb-2">
          <Pagination
            defaultCurrent={currentPage}
            total={feedBackSize}
            pageSize={pageSize}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};
